<template>
  <div
    :class="[
      'w-full min-w-0 flex',
      { 'flex-col gap-5 sm:flex-row sm:gap-0': props.stackOnMobil },
      { 'flex-row': !props.stackOnMobil },
      {'lg:gap-x-2 items-stretch' : ruesSearchbar || searchresultSearchbar},
      {'border-cta-700 ring-2 ring-cta-700 ring-offset-0 lg:ring-offset-5' : !props.from && highlightWhenEmpty && (ruesSearchbar || searchresultSearchbar)}
    ]"
  >
    <div
      :class="[
        'min-w-0',
        { 'w-full sm:flex-1 sm:basis-1/2': props.stackOnMobil },
        { 'flex-1 basis-1/2': !props.stackOnMobil },
      ]"
    >
      <div
        v-if="labelup"
        :class="['cursor-pointer text-lg mb-1 block font-semibold']"
      >
        {{ t('from') }}
        <span v-if="props.mandatoryFields">*</span>
      </div>
      <button class="block relative w-full overflow-hidden" data-datepicker :aria-label="t('select_arrival_date')" @click="onClickFrom">
        <span class="absolute top-0 left-0 py-2 h-full flex items-center ml-3">
          <UiIcon src="/svg/icons/calendar-simple.svg" width="17" height="19" class="stroke-neutral-900" />
        </span>
        <span
          :class="[
            'overflow-hidden min-w-0 w-full',
            {'pl-11 pr-3 py-3 min-h-[55px] flex items-center': normal && labelup},
            {'py-2': slim && labelup},
            {'pl-11 pr-3 pt-6 pb-1 min-h-[55px] text-lg font-semibold peer': normal && !labelup},
            {'pl-11 pr-6 pt-3 pb-1 text-lg font-semibold peer': slim && !labelup},
            {'border-cta-700 ring-1 ring-cta-700' : normal && !props.from && highlightWhenEmpty},
            {'border-neutral-200' : ((normal || slim) && props.from) || ((normal || slim) && !highlightWhenEmpty)},
            {'border-petrol-500': isActiveFrom && normal},
            {'border-petrol-500 ring-1 ring-petrol-500': isActiveFrom && slim},
            {'bg-neutral-50 ring-0' : isActiveFrom && (ruesSearchbar || searchresultSearchbar) },
            {'rounded-xl sm:rounded-l-xl sm:rounded-r-none': props.stackOnMobil && !ruesSearchbar && !searchresultSearchbar},
            {'rounded-l-xl': !props.stackOnMobil && !ruesSearchbar && !searchresultSearchbar},
            {'rounded-none sm:rounded-xl': props.stackOnMobil && (ruesSearchbar || searchresultSearchbar)},
            {'rounded-none lg:rounded-xl': !props.stackOnMobil && (ruesSearchbar || searchresultSearchbar)},
            {'pl-11 pt-6 pb-1 text-lg font-semibold min-h-[62px] peer w-full': ruesSearchbar || searchresultSearchbar},
            {'lg:pt-5 lg:min-h-[46px]': searchresultSearchbar},
            {'border bg-white text-left w-full focus:outline-hidden cursor-pointer active-input block': !ruesSearchbar && !searchresultSearchbar},
            {'text-left focus:outline-hidden focus:ring-0 focus:ring-petrol-500 flex items-center placeholder:text-neutral-900 active-input' : ruesSearchbar || searchresultSearchbar}
          ]"
        >
          <span
            v-if="label"
            :class="[
              {'absolute text-lg text-petrol-500 font-semibold duration-200 transform top-4 z-10 origin-left left-11 scale-100 -translate-y-1': slim && !props.from},
              {'absolute text-lg text-petrol-500 font-semibold duration-200 transform top-4 z-10 origin-left left-11 scale-[75%] -translate-y-3.5': slim && props.from},
              {'absolute text-lg text-petrol-500 font-semibold duration-200 transform top-1/2 z-10 origin-left left-11 scale-100 -translate-y-1/2': normal && !props.from},
              {'absolute text-lg text-petrol-500 font-semibold duration-200 transform top-4 z-10 origin-left left-11 scale-[85%] -translate-y-2.5': normal && props.from},
              {'absolute text-lg text-neutral-900 font-normal duration-200 transform z-10 origin-left left-11 scale-[80%] -translate-y-2.5': ruesSearchbar || searchresultSearchbar},
              {'top-[1.15rem]': ruesSearchbar || searchresultSearchbar},
              {'lg:top-[0.65rem]': searchresultSearchbar},
              'left-0 cursor-pointer block'
            ]"
          >
            {{ t('from') }}
            <span v-if="props.mandatoryFields">*</span>
          </span>
          <span v-if="props.from" class="pointer-events-none block min-w-0 truncate">
            {{ props.from }}
          </span>
          <span v-if="!props.from && (ruesSearchbar || searchresultSearchbar)" class="pointer-events-none block min-w-0 truncate">
            {{ t('from_placeholder') }}
          </span>
        </span>
      </button>
    </div>
    <div v-if="ruesSearchbar || searchresultSearchbar" class="border-r border-neutral-200 block h-auto"/>
    <div
      :class="[
        'min-w-0',
        { 'w-full sm:flex-1 sm:basis-1/2': props.stackOnMobil },
        { 'flex-1 basis-1/2': !props.stackOnMobil }
      ]"
    >
      <div
        v-if="labelup"
        :class="['cursor-pointer text-lg mb-1 block font-semibold']"
      >
        {{ t('to') }}
        <span v-if="props.mandatoryFields">*</span>
      </div>
      <button class="block relative w-full overflow-hidden" data-datepicker :aria-label="t('select_departure_date')" @click="onClickTo">
        <span class="absolute top-0 left-0 py-2 h-full flex items-center ml-3">
          <UiIcon src="/svg/icons/calendar-simple.svg" width="17" height="19" class="stroke-neutral-900" />
        </span>
        <span
          :class="[
            'overflow-hidden min-w-0 w-full',
            {'pl-11 pr-3 py-3 min-h-[55px] flex items-center': normal && labelup},
            {'py-2': slim && labelup},
            {'pl-11 pr-3 pt-6 pb-1 min-h-[55px] text-lg font-semibold peer': normal && !labelup},
            {'pl-11 pr-6 pt-3 pb-1 text-lg font-semibold peer': slim && !labelup},
            {'border-cta-700 ring-1 ring-cta-700' : normal && !props.from && highlightWhenEmpty},
            {'border-neutral-200' : ((normal || slim) && props.from) || ((normal || slim) && !highlightWhenEmpty)},
            {'border-petrol-500': isActiveTo && normal},
            {'border-petrol-500 ring-1 ring-petrol-500': isActiveTo && slim},
            {'bg-neutral-50 ring-0' : isActiveTo && (ruesSearchbar || searchresultSearchbar) },
            {'rounded-xl sm:rounded-r-xl sm:rounded-l-none sm:border-l-transparent': props.stackOnMobil && !ruesSearchbar && !searchresultSearchbar},
            {'rounded-r-xl border-l-transparent': !props.stackOnMobil && !ruesSearchbar && !searchresultSearchbar},
            {'rounded-none sm:rounded-xl': props.stackOnMobil && (ruesSearchbar || searchresultSearchbar)},
            {'rounded-none lg:rounded-xl': !props.stackOnMobil && (ruesSearchbar || searchresultSearchbar)},
            {'pl-11 pt-6 pb-1 text-lg font-semibold min-h-[62px] peer w-full': ruesSearchbar || searchresultSearchbar},
            {'lg:pt-5 lg:min-h-[46px]': searchresultSearchbar},
            {'border bg-white text-left w-full focus:outline-hidden cursor-pointer active-input block': !ruesSearchbar && !searchresultSearchbar},
            {'border-0 text-left focus:outline-hidden focus:ring-1 focus:ring-petrol-500 flex items-center placeholder:text-neutral-900 active-input' : ruesSearchbar || searchresultSearchbar}
          ]"
        >
          <span
            v-if="label"
            :class="[
              { 'absolute text-lg text-petrol-500 font-semibold duration-200 transform top-4 z-10 origin-left left-11 scale-100 -translate-y-1': slim && !props.to},
              { 'absolute text-lg text-petrol-500 font-semibold duration-200 transform top-4 z-10 origin-left left-11 scale-[75%] -translate-y-3.5': slim && props.to},
              { 'absolute text-lg text-petrol-500 font-semibold duration-200 transform top-1/2 z-10 origin-left left-11 scale-100 -translate-y-1/2': normal && !props.to},
              { 'absolute text-lg text-petrol-500 font-semibold duration-200 transform top-4 z-10 origin-left left-11 scale-[85%] -translate-y-2.5': normal && props.to},
              { 'absolute text-lg text-neutral-900 font-normal duration-200 transform z-10 origin-left left-11 scale-[80%] -translate-y-2.5': ruesSearchbar || searchresultSearchbar},
              {'top-[1.15rem]': ruesSearchbar || searchresultSearchbar},
              {'lg:top-[0.65rem]': searchresultSearchbar},
              'left-0 cursor-pointer block'
            ]"
          >
            {{ t('to') }}
            <span v-if="props.mandatoryFields">*</span>
          </span>
          <span v-if="props.to" class="pointer-events-none block min-w-0 truncate">
            {{ props.to }}
          </span>
          <span v-if="!props.to && (ruesSearchbar || searchresultSearchbar)" class="pointer-events-none block min-w-0 truncate">
            {{ t('to_placeholder') }}
          </span>
        </span>
      </button>
    </div>
  </div>
  <input v-if="props.nameFrom" :name="props.nameFrom" :value="props.from" type="hidden">
  <input v-if="props.nameTo" :name="props.nameTo" :value="props.to" type="hidden">
</template>

<script setup lang="ts">
import type { DesignVariant } from '~/types/ui/DesignVariant'
import { isDesignVariant } from '~/types/ui/DesignVariant'
import UiIcon from '~/components/ui/UiIcon.vue'
const { translate: t } = useTranslations('UiDaterangeInput')

const props = defineProps({
  design: {
    type: String as PropType<DesignVariant>,
    default: 'normal',
    validator: (value: string) => isDesignVariant(value)
  },
  highlightWhenEmpty: {
    type: Boolean,
    default: false
  },
  label: {
    type: String,
    default: ''
  },
  activeInput: {
    type: Boolean,
    default: false
  },
  placeholderFrom: {
    type: String,
    default: ''
  },
  placeholderTo: {
    type: String,
    default: ''
  },
  nameFrom: {
    type: String,
    default: null
  },
  nameTo: {
    type: String,
    default: null
  },
  from: {
    type: String,
    default: ''
  },
  to: {
    type: String,
    default: ''
  },
  mandatoryFields: {
    type: Boolean,
    default: false
  },
  activeField: {
    type: String as PropType<'from' | 'to' | null>,
    default: null
  },
  stackOnMobil: {
    type: Boolean,
    default: false
  }
})

const emit = defineEmits(['update:from', 'update:to', 'updateTemporaryBis', 'clickFrom', 'clickTo'])

// Label choices
const label = computed(() => props.label === 'normal')
const labelup = computed(() => props.label === 'up')

// Design choices
const normal = computed(() => props.design === 'normal')
const slim = computed(() => props.design === 'slim')
const isActiveFrom = computed(() => props.activeField === 'from')
const isActiveTo = computed(() => props.activeField === 'to')
const ruesSearchbar = computed(() => props.design === 'ruesSearchbar')
const searchresultSearchbar = computed(() => props.design === 'searchresultSearchbar')
function resetTo (status = true) {
  if (status) {
    emit('updateTemporaryBis', null)
    emit('update:to', null)
  } else {
    emit('updateTemporaryBis', props.to)
  }
}
const onClickFrom = () => {
  resetTo(false)
  emit('clickFrom')
}
const onClickTo = () => {
  if (!props.from) {
    emit('clickFrom')
  } else {
    emit('clickTo')
  }
}
</script>

